<template>
  <div class="audit-progress">
    <div class="progress-content">
      <div class="progress-bar">
        <div class="bar-bg"></div>
        <div class="bar-ing" :class="{king: queueProcess === 'KING_QUEUE'}" :style="barStyle"></div>
      </div>
      <div class="progress-header">
        <div class="header-num" :style="numStyle">{{progress}}%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuditProgress',
  props: {
    progress: {
      type: Number,
      default: 0
    },
    queueProcess: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 进度值样式
    numStyle () {
      return {
        left: this.progress + '%'
      }
    },
    // 进度条样式
    barStyle () {
      return {
        width: this.progress + '%'
      }
    },
    // 箭头样式
    arrowStyle () {
      return {
        left: this.progress + '%'
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

@keyframes breath {
  to {
    transform: translateX(50%) translateY(-50%) scale(1.2);
    box-shadow: 0 0 10px 0 #FF2800;

  }
}

@barHeight: 8px;
.audit-progress{
  width: 100%;
  .progress-content{
    .progress-header{
      display: flex;
      justify-content: space-between;
      position: relative;
      font-size: 26px;
      color: #ABABAB;
      .header-num{
        margin-top: 11px;
        color: #666666;
        position: absolute;
        transform: translateX(-50%);
        transition: .3s linear;
      }
    }
    .progress-bar{
      position: relative;
      margin-top: 15px;
      .bar-bg{
        height: @barHeight;
        background-color: #E5E5E5;
        border-radius: 20px;
        &::after{
          content: "";
          display: block;
          width: 32px;
          height: 32px;
          background: url(../images/icon_done.png) center no-repeat;
          background-size: 100%;
          position: absolute;
          right: -4px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .bar-ing{
        height: @barHeight;
        background: linear-gradient(90deg, #FFB35C 0%, #FD7A16 100%);
        position: absolute;
        top: 0;
        left: 0;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        transition: .3s linear;
        &.king {
          &::after {
          box-shadow: 0 0 10px 0 rgba(0,0,0,0);
          animation: breath 0.75s ease-in-out infinite alternate;
          }
        }
        &::before{
          content: "";
          display: block;
          width: 90px;
          height: 32px;
          background: url(../images/guangdian2x.gif) center no-repeat;
          background-size: 100%;
          position: absolute;
          right: 0;
          top: 0;
          z-index: 1;
        }
        &::after{
          content: "";
          display: block;
          width: 26px;
          height: 26px;
          background: url(../images/img_yuan.png) center no-repeat;
          background-size: 100%;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateX(50%) translateY(-50%) scale(1);
          z-index: 2;
          border-radius: 100%;
        }
      }
    }
  }
}
</style>